var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNtak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 214 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.07 89.6399H213.1V88.75C212.99 82.13 211.67 75.8 209.36 69.9799H189.35V134.01C203.46 124.61 212.81 108.66 213.1 90.5099V89.6499L213.07 89.6399Z",
    className: "svgFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.93 44V143.5C154.51 143.12 157.15 142.91 159.84 142.91C165.36 142.91 170.68 142.07 175.68 140.52V44H151.93Z",
    className: "svgFill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9 61.7202C2.9 69.8402 0 79.4002 0 89.6302H0.049999H0C0 108.11 9.41 124.38 23.7 133.94V61.7202H7.9Z",
    className: "svgFill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3601 101.78V140.5C42.3901 142.07 47.7401 142.92 53.2901 142.92C55.9501 142.92 58.5601 143.12 61.1101 143.5V101.78H37.3601Z",
    className: "svgFill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.56 70.0898L69.4499 85.1498V90.4798H74.7199L74.75 147.37C84.64 151.73 92.92 159.02 98.5599 168.13H99.64V135.83C99.64 132.07 102.69 129.02 106.45 129.02H106.49C110.25 129.02 113.3 132.07 113.3 135.83V168.13C113.3 168.13 114.46 168.13 114.54 168.13C120.16 159.05 128.41 151.78 138.26 147.42L138.29 90.4898H143.48V85.1598L106.56 70.0898ZM113.3 115.46H99.64V101.8H113.3V115.46Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNtak);
export default __webpack_public_path__ + "static/media/ntak.99f8a3a39a74e7e294e198e568be310f.svg";
export { ForwardRef as ReactComponent };